import Api, { axiosInstance } from '../Api';

export default class Price {
  endpoint = 'Price';

  // New "Get" request to replace "CurrencyConversion". Now all the checking for shopping cart items happen in backend,
  // so no "body" is needed and only requires userId and key.
  // "country" is an optional parameter for currency conversion (need further change in database),
  // leave it as blank for now.
  /*   async GetTotalPrice() {
    try{
      const r = await axiosInstance.get(
        `/${this.endpoint}/GetTotalPrice?userId=${Api.USER_NAME}&key=${Api.API_KEY}&country=`
      );
      return r.data;
    } catch (error) {
      return({"Result":null,"Error": error})
    }
  }  */

  async GetPriceSummary() {
    try {
      const r = await axiosInstance.get(`/${this.endpoint}/Summary`);
      return r.data;
    } catch (error) {
      return { Result: null, Error: error };
    }
  }

  // API for getting price based on user account, dataset and period
  // If user is not logged in yet, leave “userId” and “key” as empty.
  async GetDatasetPriceByPeriod(
    datasetId: string,
    startTime: string,
    endTime: string
  ) {
    try {
      const r = await axiosInstance.get(
        `/${this.endpoint}/GetDatasetPriceByPeriod`,
        {
          params: {
            datasetId: datasetId,
            startTime: startTime,
            endTime: endTime,
          },
        }
      );
      return r.data;
    } catch (error) {
      return { Result: null, Error: error };
    }
  }

  /* async GetOnlinePaymentLimit(): Promise<number> {
    const r = await axiosInstance.post(`/${this.endpoint}/GetOnlinePaymentLimit`, null, {
      params: {
        key: Api.API_KEY,
      },
    });
    if (isEmpty(r.data.Error)) {
      return r.data.Value;
    }

    return 0;
  } */

  /**
   * payment api
   * usage in
   * braintree.client.create({
       authorization: clientToken
      },
   */
  /*   async getToken(): Promise<string> {
    try {
      const r = await axiosInstance.get(`/payment/gettoken`, {
        params: {
          key: Api.API_KEY,
        },
      });
      return r.data;
    } catch (error) {
      console.log(error);
      return Promise.resolve('');
    }
  } */
}
